export default __webpack_public_path__ + "static/media/services-garden-walls.5ebb9b5a.jpg";